import { create } from "zustand";
import { persist } from "zustand/middleware";
import { TTimeToReleaseUpload } from "./Store.types";

interface TimeToReleaseUploadState {
  timeToReleaseChoice: TTimeToReleaseUpload;
  setTimeToReleaseChoice: (choice: TTimeToReleaseUpload) => void;
}

export const useTimeToReleaseUploadStore = create<TimeToReleaseUploadState>()(
  persist(
    (set) => ({
      timeToReleaseChoice: null,
      setTimeToReleaseChoice: (choice) => set({ timeToReleaseChoice: choice }),
    }),
    {
      name: "time-to-release-upload",
    }
  )
);
